import CheckOtpForm from './CheckOtpForm';
import SendOtpForm from './SendOtpForm';
import { useState } from 'react';
import { useFormik } from 'formik';
import { sendOtp } from '@services/Api';
import ToastSuccess from '../toast/ToastSuccess';
import ToastError from '../toast/ToastError';

export default function LoginModal({ setFlow }) {
  const [loginStep, setLoginStep] = useState(1);

  const modalLoginHandler = () => {
    setLoginStep(1);
  };
  const [loading, setLoading] = useState(false);
  const formik = useFormik({
    initialValues: {
      phone: '',
    },
    validate: (values) => {
      const errors = {};
      if (!values.phone) {
        errors.phone = 'شماره موبایل را وارد کنید';
      } else if (!/(^0?9[0-9]{9}$)|(^\u06F0\u06F9[\u06F0-\u06F9]{9})$/.test(values.phone)) {
        errors.phone = 'شماره موبایل وارد شده اشتباه است';
      }

      return errors;
    },
    onSubmit: (values) => {
      setLoading(true);
      sendOtp(values.phone[0] == '0' ? values.phone : '0' + values.phone)
        .then((res) => {
          if (res.status == 'success') {
            ToastSuccess({ content: 'کد یکبار مصرف برای شما ارسال شد' });
            setLoginStep(2);
          } else {
            ToastError({ content: 'مشکلی پیش آمد، مجدداً تلاش کنید' });
          }
        })
        .catch((e) => {
          ToastError({ content: 'مشکلی پیش آمد، مجدداً تلاش کنید' });
        })
        .finally((e) => {
          setLoading(false);
        });
    },
  });

  return (
    <div className="flex flex-col w-full h-fit items-center justify-center">
      {loginStep == 1 ? (
        <SendOtpForm
          modalLoginHandler={modalLoginHandler}
          formik={formik}
          loading={loading}
          setLoginStep={setLoginStep}
        />
      ) : loginStep == 2 ? (
        <CheckOtpForm
          phone={formik.values.phone}
          modalLoginHandler={modalLoginHandler}
          loading={loading}
          setLoading={setLoading}
          formik={formik}
          setFlow={setFlow}
          setLoginStep={setLoginStep}
        />
      ) : null}
    </div>
  );
}
